export default __webpack_public_path__ + "static/media/T24DefenceLogo_LightHD.7f2caeaf.png";